export default __webpack_public_path__ + "static/media/989887e1-2fc8-43e3-bbe0-6e02da8d5d1a.fbb7e7a3.JPG";